import { ApolloClient, InMemoryCache } from '@apollo/client';
import graphqlCacheConfig from '../../common/graphqlCache';

const client = new ApolloClient({
  // eslint-disable-next-line no-underscore-dangle
  cache: new InMemoryCache(graphqlCacheConfig).restore(window.__APOLLO_STATE__),
  uri: '/graphql',
});

export default client;
